import { api } from 'services/api'

export async function createUser(payload) {
  const { data } = await api.post('/users', payload)

  return data
}
